var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.windowUrl)?_c('v-btn',{staticClass:"rotated",staticStyle:{"margin-right":"-65px"},attrs:{"absolute":"","dark":"","bottom":"","right":"","color":"pink"},on:{"click":_vm.launchFeedbackPage}},[_c('v-icon',{staticClass:"pr-5"},[_vm._v("mdi-message")]),_vm._v(" Feedback ")],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }